import applyapis  from "../../api/apply";

export default {
    name: "OutApply",

    data() {
        return {
            personName:'',
            personCode:'',
            personCompanyText:'',
            money:'',
            loanName:'',
            area:'',
            areaList:[],
            bankList:[],
            bank:'',
            firstBusiness:'',
            secondBusiness:[],
            BusinessDetail:'',
            businessShow:false,
            firstBusinessOption:['电商','种植','养殖','农产品加工','农资农机销售','农产品购销','农业服务','农业旅游农家乐','农业相关工程','其他'],
            xmlist:['肉牛','柑桔','粮食','蔬菜','牲猪','水产','羊','鸡','砂梨','农业服务','农业旅游','苗木','园林绿化工程','农家乐','农资','秸秆回收','青储','饲料','其他'],
            secondBusinessTitle:'二级分类',
            secondBusinessPlaceHolder:'输入对应主营项目的二级类目',
            peopleCount:'',
            lastYearIncome:'',
            lastYearTax:'',
            lastYearProfit:'',
            phone:'',
            chooseType:'2',
            company:'',
            companyCode:'',
            loanList:[],
            dialogVisible:false,
            companyList:[],
            pageIndex:1,
            pageSize:20,
            companyTotalCount:0,
            addVisible:false,
            flowId:'',
        }
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if(meta&&meta.permBtns.length>0){
            this.permBtns = meta.permBtns
        }
    },
    created() {
        this.getLoanList()
        this.getAreaList()
    },
    activated() {
      // let that = this
      
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
      calcTableHeight(){
        this.$nextTick(() => {
          var height1=$(".content-box .content").height();
          var height=height1-50-20-40;
          this.scrollHeight = height;
        });
      },
        getAreaList(){
            applyapis.getAreaList({}).then(res => {
                this.areaList=res;
            });
        },
        changeArea(){
            let areaCode =this.area
            let _this = this
            applyapis.getBankByAreaCode({areaCode:areaCode}).then(res=>{
                _this.bankList = res;
                if(_this.bankList.length===0){
                    _this.bank = ''
                }
            })
        },
        getLoanList(){
            applyapis.getLoanList({}).then(res => {
                this.loanList=res;
            });
        },
        openCompanyDialog(){
            if(this.personName===''){
                this.$message.error("请输入申请者姓名");
                return;
            }
            this.dialogVisible = true
            this.pageIndex = 1
            this.companyTotalCount = 0
            this.companyList = []
            this.getCompanyList()
        },
        getCompanyList(){
            let _this = this
            applyapis.getCompanyPage({page:_this.pageIndex,name:_this.personName}).then(res=>{
                if(res.Paging==null){
                    _this.companyList = []
                }else{
                    _this.companyList = res.Result
                    _this.companyTotalCount = Number(res.Paging.TotalRecords)
                }
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.pageIndex = val;
            this.getCompanyList()
        },

        chooseCompany(row){
          this.company = row.Name
          this.companyCode = row.CreditCode
          this.dialogVisible = false
        },
        verifyPhone (val) {
            return /^1\d{10}$/.test(val) // 返回true或false
        },
        verifyNumber(val){
          return /(^[1-9]\d*$)/.test(val)
        },
        onSubmit(){
            let applyObj = {}
            if(this.chooseType==='2'){
                applyObj.personCompanyText = this.company
                applyObj.personCompanyFlag = 'company'
                applyObj.personCompanyCode = this.companyCode
            }else{
                applyObj.personCompanyFlag = 'person'
                applyObj.personCompanyText = this.personName
                applyObj.personCompanyCode = this.personCode
            }
            applyObj.phone = this.phone
            applyObj.personName =this.personName
            applyObj.personCode = this.personCode
            applyObj.money = this.money
            applyObj.loanName =this.loanName
            if(!this.area){
                this.$message.error("请选择区域")
                return
            }
            
            if(this.secondBusiness.length==0){
                this.$message.error("请您选择二级业务")
                return
            }
            if(this.businessShow&&this.BusinessDetail==""){
                this.$message.error("请您输入业务说明")
                return
            }
            applyObj.area = this.getAreaItem(this.area).AreaName
            applyObj.bank = this.bank
            applyObj.firstBusiness = this.firstBusiness
            applyObj.peopleCount = this.peopleCount
            applyObj.lastYearIncome = this.lastYearIncome
            applyObj.lastYearTax = this.lastYearTax
            applyObj.lastYearProfit = this.lastYearProfit
            let check = this.checkApplyInfo(applyObj)
            if(check.flag){
                //发送请求
                let _this = this
                if(this.businessShow) applyObj.secondBusiness="";
                    else applyObj.secondBusiness=this.BusinessDetail;
                applyObj.ThirdBusiness=this.secondBusiness.join(",");
                applyapis.addLoanApply(applyObj).then(res=>{
                    if(res){
                        this.$message({
                            message: '申请成功',
                            type: 'success',
                            onClose:function(){
                                //关闭这个tag，且跳转到流程管理列表
                                //如果流程管理tag存在，跳转过去之后还要刷新
                                //如果流程管理tag不存在，直接打开应该就可以
                                _this.$router.push("/Flow/index")
                                _this.emptyData()
                            }
                        });
                    }else{
                        _this.$message.error("提交失败")
                    }
                })
            }else{
                this.$message.error(check.msg);
            }
        },
        onSubmit2(){
            this.addVisible=true;
        },
        addLoanApply2(){
            let _this = this
            var flowId=this.flowId;
            if(flowId=="")this.$message.error("请输入流程编号");
            else 
            applyapis.addLoanApply2({Id:flowId}).then(res=>{
                if(res){
                    _this.addVisible=false;
                    _this.$message({
                        message: '申请成功',
                        type: 'success',
                        onClose:function(){
                            //关闭这个tag，且跳转到流程管理列表
                            //如果流程管理tag存在，跳转过去之后还要刷新
                            //如果流程管理tag不存在，直接打开应该就可以
                            _this.$router.push("/Flow/index")
                            _this.emptyData()
                        }
                    });
                }else{
                    _this.message({
                        message:"提交失败",
                        type: 'error',
                    })
                }
            })
        },
        emptyData(){
                this.personName = ''
                this.personCode = ''
                this.personCompanyText = ''
                this.money = ''
                this.loanName = ''
                this.area = ''
                this.bank = ''
                this.firstBusiness = ''
                this.secondBusiness = []
                this.BusinessDetail="",
                this.businessShow=false,
                this.secondBusinessTitle = '二级分类'
                this.secondBusinessPlaceHolder = '输入对应主营项目的二级类目'
                this.peopleCount = ''
                this.lastYearIncome = ''
                this.lastYearTax = ''
                this.lastYearProfit = ''
                this.phone = ''
                this.chooseType = '2'
                this.company = ''
                this.companyCode = ''
                this.pageIndex = 1
                this.pageSize = 20
                this.companyTotalCount = 0
        },
        getLoanItem(){
          for(let i=0;i<this.loanList.length;i++){
              if(this.loanList[i].LoanName===this.loanName){
                  return this.loanList[i]
              }
          }
        },
        getAreaItem(){
          for(let i=0;i<this.areaList.length;i++){
              if(this.areaList[i].AreaCode === this.area){
                  return this.areaList[i]
              }
          }
        },
        checkApplyInfo(info){
            if(info.personName===""){
                return {flag:false,msg:"请您输入申请人姓名"}
            }
            if(info.personCode===""){
                return {flag:false,msg:'请你输入申请人身份证号码'}
            }
            if(this.chooseType==='2'&&this.company===""){
                return {flag:false,msg:'您必须选择一个企业申请'}
            }
            if(info.loanName === ""){
                return {flag:false,msg:"请您选择贷款类型"}
            }
            if(!this.verifyNumber(info.money)){
                return {flag:false,msg:"贷款金额请输入正整数"}
            }else{
                let loanItem = this.getLoanItem()
                if(Number(info.money)>Number(loanItem.MaxMoney)||Number(info.money)<Number(loanItem.MinMoney)){
                    return {flag:false,msg:'贷款金额须在'+loanItem.MinMoney+"-"+loanItem.MaxMoney+"(万元)之间"}
                }
            }
            if(info.area===""){
                return {flag:false,msg:'请您选择区域'}
            }
            if(info.bank === ""){
                return {flag:false,msg:'请您选择银行'}
            }
            if(info.firstBusiness === ""){
                return {flag:false,msg:"请您选择主营业务"}
            }
            //如果选择的是公司，那么还需要判断公司的字段
            if(!this.verifyNumber(info.peopleCount)){
                return {flag:false,msg:"请您输入从业人数"}
            }
            if(info.lastYearIncome === ""){
                return {flag:false,msg:'请您输入上年营业收入'}
            }
            if(info.lastYearTax === ""){
                return {flag:false,msg:'请您输入上年税收'}
            }
            if(info.lastYearProfit === ""){
                return {flag:false,msg:'请您输入上年利润'}
            }
            if(info.phone === ""){
                return {flag:false,msg:"请输入联系方式"}
            }
            if(!this.verifyPhone(info.phone)){
                return {flag:false,msg:'请您输入正确的联系方式'}
            }
            return {flag:true}
        },
        onFirstBusinessChooseConfirm(value){
            this.firstBusiness = value
            //变更二级分类的标题和placeholder
            this.changeSecondBusinessShow(value)
        },
        changeSecond(){
         var value=this.secondBusiness;
         for(var i=0;i<value.length;i++){
            if(value[i]=="其他"){
                this.businessShow=true;
                return
          }
          }
          this.businessShow=false;
        },
        changeSecondBusinessShow(value){
            switch (value) {
                case '电商':
                    this.secondBusinessTitle = '销售类目'
                    this.secondBusinessPlaceHolder = '如：生鲜、粮油'
                    break;
                case '种植':
                    this.secondBusinessTitle = '种植作物'
                    this.secondBusinessPlaceHolder = '如：水稻、棉花'
                    break;
                case '养殖':
                    this.secondBusinessTitle = '养殖种类'
                    this.secondBusinessPlaceHolder = '如：猪、肉牛'
                    break;
                case '农产品加工':
                    this.secondBusinessTitle = '加工品类'
                    this.secondBusinessPlaceHolder = '如：粮食加工、柑橘加工'
                    break;
                case '农资农机销售':
                    this.secondBusinessTitle = '销售品类'
                    this.secondBusinessPlaceHolder = '如：播种机、拖拉机、农资销售'
                    break;
                case '农产品购销':
                    this.secondBusinessTitle = '产品类型'
                    this.secondBusinessPlaceHolder = '如：柑橘、蔬菜'
                    break;
                case '农业服务':
                    this.secondBusinessTitle = '服务项目'
                    this.secondBusinessPlaceHolder = '如：收割、无人机植保'
                    break;
                case '农业旅游农家乐':
                    this.secondBusinessTitle = '产业类型'
                    this.secondBusinessPlaceHolder = '如：玫瑰园、果园、农家乐餐饮'
                    break;
                case '农业相关工程':
                    this.secondBusinessTitle = '工程内容'
                    this.secondBusinessPlaceHolder = '如：大棚、土壤改良、绿化工程'
                    break;
                case '其他':
                    this.secondBusinessTitle = '经营项目'
                    this.secondBusinessPlaceHolder = '请填经营项目'
                    break;
            }
        },

    },
  };
